<template>
    <div>
        <p>Verificando suas credenciais...</p>
    </div>
</template>

<script>

import store from "@/store";
import env from "@/env";

export default {

    methods: {
        async verifyCredentials() {
            const token = this.$route.params.token;

            console.log(token)
            // Verifica se o token existe
            if (token) {
                try {
                    localStorage.setItem('token', token)
                    const result = await this.$store.dispatch("auth/initialize", token);
                    console.log(result)
                    if (result) {
                        const currentUser = store.state.auth.user;

                        console.log(currentUser)
                        if (!currentUser.plan_id || !env.checkout) {
                            await this.$router.push('/assinatura');
                        } else {
                            // const token = localStorage.getItem('token')
                            await this.$router.push('/home');
                        }
                    }
                } catch (e) {
                    console.error('Mentors Login By Google: ', e);
                    this.$notifyError('Erro ao logar com o Google!');
                    await this.$router.push('/login');
                }

            } else {
                // Redireciona para o login se não tiver token
                await this.$router.push('/login');
            }
        }
    },

    mounted() {
        console.log('mounted')
        this.verifyCredentials();
    }
};
</script>
